import userService from "../../../engines/services/userService";
import O1HD from "../../../engines/gameEngine";

const {ccclass, property} = cc._decorator;
/**
 *
 */
@ccclass
export default class ValueNode extends cc.Component {

    onLoad () {}

    start () {
        //改变值
        O1HD.on("ValueNode.changeValue" , this.changeValue , this );
    }

    update (dt) {
        this.node.getChildByName("lbStronger").getComponent(cc.Label).string = `${O1HD.getServices().userSrv.getStronger()}%`;
        this.node.getChildByName("lbMood").getComponent(cc.Label).string = `${O1HD.getServices().userSrv.getMood()}%`;
        this.node.getChildByName("lbHealth").getComponent(cc.Label).string = `${O1HD.getServices().userSrv.getHealth()}%`;
        this.node.getChildByName("tili").getComponent(cc.Sprite).fillRange = O1HD.getServices().userSrv.getStronger() / 100;
        this.node.getChildByName("jingshen").getComponent(cc.Sprite).fillRange = O1HD.getServices().userSrv.getMood() / 100;
        this.node.getChildByName("jiankang").getComponent(cc.Sprite).fillRange = O1HD.getServices().userSrv.getHealth() / 100;
    }

    /**
     * 值的变化
     * @param type
     * @param value
     */
    changeValue( type : string , value : number  ){
        if ( value == 0 ) {
            return;
        }
        let desNode : cc.Node = null;
        if ( type == "tili" ) {
            //体力
            desNode = this.node.getChildByName("tili");
        }else if( type == "xinqing" ){
            //心情
            desNode = this.node.getChildByName("jingshen");
        }else if( type == "jiankang" ){
            //健康
            desNode = this.node.getChildByName("jiankang");
        }

        if ( desNode ) {
            let tempNode : cc.Node = null;
            if ( value > 0 ) {
                if ( desNode.getChildByName("lbAdd") ) {
                    tempNode = cc.instantiate( desNode.getChildByName("lbAdd"));
                    tempNode.getComponent(cc.Label).string = `+${value}`;
                }
            }else{
                if ( desNode.getChildByName("lbReduce") ) {
                    tempNode = cc.instantiate( desNode.getChildByName("lbReduce"));
                    tempNode.getComponent(cc.Label).string = `${value}`;
                }
            }
            //
            if ( tempNode ) {
                desNode.addChild( tempNode );
                tempNode.active = true;
                cc.tween( tempNode )
                    .by( 1.5 , { y : 20 ,opacity : 50 })
                    .call(()=>{
                        tempNode.removeFromParent();
                        tempNode.destroy();
                    })
                    .start();
            }
        }
    }

}
